import { render, staticRenderFns } from "./BlanketVOBList.vue?vue&type=template&id=40844701&scoped=true"
import script from "./BlanketVOBList.vue?vue&type=script&lang=js"
export * from "./BlanketVOBList.vue?vue&type=script&lang=js"
import style0 from "./BlanketVOBList.vue?vue&type=style&index=0&id=40844701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40844701",
  null
  
)

export default component.exports